import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactFormComponent {
  @Input()header = '';
  @Input()subHeader = '';
  @Input()description = '';
  @Input()type = '';
  @Input()image: string = '';
  @Input() allBrands: string[] = [];

  formNotSubmitted$ = new BehaviorSubject(true);

  onSubmit() {
    this.formNotSubmitted$.next(false);
  }


}
